import { Storage } from "utils/clientStorage";
import makeStore from "utils/makeStore";

const token = window !== undefined ? Storage.getItem("TOKEN") || null : null;
const userId = window !== undefined ? Storage.getItem("USER_ID") || null : null;
const profile = window !== undefined ? Storage.getItem("PROFILE") || {} : {};
const initialState = {
  token: token,
  userId: userId,
  isAuthenticated: false,
  loading: false,
  error: null,
  profile: profile,
  sessionKey: "",
  todo: {},
};
export const INIT_SIGNUP = "INIT_SIGNUP";
export const ERROR_OCCUR = "ERROR_OCCUR";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const INIT_LOGIN = "INIT_LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";

const AuthReducer = (state = initialState, action) => {
  const newState = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case INIT_SIGNUP:
      newState.loading = true;
      newState.error = null;
      break;
    case ERROR_OCCUR:
      newState.loading = false;
      newState.error = action.error;
      break;
    case SIGNUP_SUCCESS:
      newState.loading = false;
      newState.error = null;
      break;
    case INIT_LOGIN:
      newState.loading = true;
      newState.error = null;
      newState.isAuthenticated = false;
      newState.token = null;
      break;
    case LOGIN_SUCCESS:
      newState.loading = false;
      newState.error = null;
      newState.isAuthenticated = true;
      newState.token = action.token;
      newState.userId = action.userId;
      newState.profile = action.profile;
      newState.sessionKey = action.sessionKey;
      newState.todo = action.todo;
      addAuthToDevice({
        token: action.token,
        userId: action.userId,
        profile: action.profile,
        todo: action.todo,
      });
      break;
    case LOGOUT:
      newState.loading = false;
      newState.error = null;
      newState.isAuthenticated = false;
      newState.token = null;
      newState.userId = null;
      removeAuthFromDevice();
      break;

    default:
      return state;
  }
  return newState;
};

export const addAuthToDevice = (payload) => {
  Storage.setItem("USER_ID", payload.userId);
  Storage.setItem("TOKEN", payload.token);
  Storage.setItem("PROFILE", payload.profile);
  Storage.setItem("TODO", payload.todo);
};

export const removeAuthFromDevice = () => {
  Storage.removeItem("USER_ID");
  Storage.removeItem("TOKEN");
  Storage.removeItem("TODO");
  Storage.removeItem("PROFILE");
};

const [AuthProvider, useAuthStore, useAuthDispatch] = makeStore(
  AuthReducer,
  initialState
);

export { AuthProvider, useAuthStore, useAuthDispatch };
